import React from 'react';
const bonuses = [{
  num: '01',
  emoji: '🔥',
  title: 'Kit Accoglienza & Arredo Aula',
  desc: 'Decorazioni, cartelli e attività per un rientro a scuola indimenticabile.'
}, {
  num: '02',
  emoji: '📅',
  title: "L'Agenda dell’Insegnante d’Arte",
  desc: 'Il planner definitivo per organizzare lezioni, scadenze e scoperte creative.'
}, {
  num: '03',
  emoji: '🎨',
  title: 'Flip-cards dei Grandi Maestri',
  desc: 'Fiche didattiche sui geni dell’arte pronte da visualizzare o stampare.'
}, {
  num: '04',
  emoji: '🔍',
  title: 'Laboratori di Riciclo Creativo',
  desc: "10 progetti eco-friendly per educare alla sostenibilità e all'Agenda 2030."
}, {
  num: '05',
  emoji: '🏆',
  title: 'Diplomi e Certificati Finali',
  desc: 'Attestati d’onore per premiare il talento e l’impegno dei tuoi piccoli artisti.'
}, {
  num: '06',
  emoji: '📝',
  title: 'Audio-Storie d’Arte',
  desc: "Racconti suggestivi da leggere per immergere la classe nella magia dell'opera."
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-10">
      <div className="max-w-4xl mx-auto" data-id="element-11">
        <div className="text-center mb-14" data-id="element-12">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-3 tracking-tight" data-id="element-13">
            6 Bonus Esclusivi Inclusi
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium mb-2" data-id="element-14">
            (Senza costi extra)
          </p>
          <p className="text-badge-red font-black text-xl sm:text-2xl line-through opacity-90" data-id="element-15">
            Valore totale dei bonus: € 49
          </p>
        </div>

        <div className="space-y-4" data-id="element-16">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-transform hover:-translate-y-1 hover:border-secondary/30 group" data-id="element-17">
              {/* Emoji + Number Badge */}
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-secondary/20 to-secondary/5 border border-secondary/20 flex items-center justify-center flex-shrink-0 text-2xl shadow-inner group-hover:from-secondary/30 transition-colors" data-id="element-18">
                {bonus.emoji}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0" data-id="element-19">
                <h4 className="text-text-main font-bold text-lg sm:text-xl mb-0.5" data-id="element-20">
                  {bonus.title}
                </h4>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-21">
                  {bonus.desc}
                </p>
              </div>

              {/* GRATIS badge */}
              <span className="bg-secondary/10 text-secondary border border-secondary/20 px-3 py-1.5 rounded-lg font-black text-sm sm:text-base flex-shrink-0 shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-22">
                GRATIS
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}